import {
  BusinessChallengesEnum,
  ChallengeUpdateArgsChallengeNumber,
} from '@platform/client/schemas';
import { FormsInputDropdown } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../../application/components/ApplicationPageContent';
import BackgroundImage from '../../../application/images/Section9.png';
import { challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';
import { useParams } from 'wouter';
import { navigate } from 'wouter/use-browser-location';
import { ROUTES } from '../../../routes/consts';
import { ApplicationMultilineInput } from '../../../application/components/ApplicationMultilineInput';

type FormValues = {
  thirdBusinessChallenge: BusinessChallengesEnum | null;
  thirdBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeThree = () => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const { data: challengeData } = BusinessChallenges.useGetOrganizationBusinessChallenges(
    parseInt(organizationId),
  );
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      thirdBusinessChallenge: challengeData?.challenges?.[2]?.challenge as BusinessChallengesEnum,
      thirdBusinessChallengeDescription: challengeData?.challenges?.[2]?.challengeContext,
    },
  });

  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(
            parseInt(organizationId),
          ),
        });
        navigate(`/platform${ROUTES.DASHBOARD}`);
      },
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    if (data.thirdBusinessChallenge && data.thirdBusinessChallengeDescription) {
      updateChallengeMutator.mutate({
        organizationId: parseInt(organizationId),
        data: {
          challenge_number: challengeData?.challenges?.[2]
            ?.challengeNumber as ChallengeUpdateArgsChallengeNumber,
          challenge_value: data.thirdBusinessChallenge,
          challenge_context: data.thirdBusinessChallengeDescription,
        },
      });
    }
  };

  return (
    <ChallengeFormBackground onSubmit={handleSubmit(submit)} backgroundImage={BackgroundImage}>
      <ApplicationPageContent
        title="Tell us about the challenges you're working through"
        description={
          'The more context you share, the better we can recommend projects that align with your needs.'
        }
      >
        <FormsInputDropdown
          control={control}
          name='thirdBusinessChallenge'
          label='Third business challenge'
          placeholder='Select your third challenge'
          items={challengeOptions}
          type='default'
          rules={{ required: 'Select a challenge your organization needs help with to continue' }}
          error={errors.thirdBusinessChallenge}
          inputDisabled
        />
        <ApplicationMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'thirdBusinessChallengeDescription'}
          formsError={errors.thirdBusinessChallengeDescription}
          rules={{ maxLength: 500, required: 'Tell us more about this challenge to continue' }}
          characterCount={500}
          extendedHeight
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
